
import axios from "axios";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest } from "components/Types/GeneralTypes";
import { alertService } from "components/Varios/alert_service";
import config from "config.json"
import { authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { SolicitudesPermisosPorAprobar, SolicitudesPorAprobar } from "../../DirectivoUnidad/AprobacionSolicitudes/TypesAprobacionSolicitudes";

export async function ObtenerInformacionSolicitudesDoctor() {
    const URL = config.SERVER_URL + "Aprobacion/Doctor"
    const datosUsuario: UserData = authenticationService.currentUserValue;
    var resultado: ResponseRequest = { status: -1 }
    try {
        const respuesta = await axios.get(URL,
            {
                headers: authHeaderWithUserData(datosUsuario)
            })
        const datos: SolicitudesPermisosPorAprobar[] | string = respuesta.data;

        if (typeof (datos) === "string") {
            resultado = { status: respuesta.status, dataResponse: datos }
        }
        else {
            const datosMapeados: SolicitudesPermisosPorAprobar[] = MapearSolicitudesPermisosPorAprobar(datos)
            resultado = { status: respuesta.status, dataResponse: datosMapeados }
        }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            resultado = { status: error.response.status, errorMessage: error.response.data }
        }

    }
    return resultado;
}

export function MapearSolicitudesPermisosPorAprobar(datos: SolicitudesPermisosPorAprobar[]) {
    const datosMapeados: SolicitudesPermisosPorAprobar[] = datos.map((val, ind) => {
        return {
            ...val,
            acciones: {
                idPermiso: val.idPermiso,
                idPersona: val.idPersona,
                fechaSolicitud: val.fechaSolicitud,
                fechaInicio: val.fechaInicio,
                fechaFin: val.fechaFin,
                horaInicio: val.horaInicio,
                horaFin: val.horaFin,
                nombres: val.nombres,
                aprueba: val.aprueba,
                refArchivo1: val.refArchivo1,
                tipoPermiso: val.tipoPermiso,
                tiempo: val.tiempo,
                doctor: val.doctor,
                idTipoPermiso: val.idTipoPermiso,
                refArchivoInforme: val.refArchivoInforme,
                estadoPermiso: val.estadoPermiso,
                horasDif: val.horasDif,
                estadoParse: val.estadoParse
            }
        }
    })
    return datosMapeados
}